import { createSlice } from '@reduxjs/toolkit'

export const stepSlice = createSlice({
  name: 'step',
  initialState: {
    value: 1,
  },
  reducers: {
    setStep: (state, action) => {
      state.value = action.payload || 1;
    },
  },
})

export const { setStep } = stepSlice.actions

export default stepSlice.reducer
